import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';
import { 
  BarChart3, 
  MessageSquare, 
  Settings, 
  Shield, 
  Activity,
  Clock,
  TrendingUp,
  AlertTriangle
} from 'lucide-react';
import { apiService } from '../services/api';
import './Sidebar.css';

const Sidebar = () => {
  const location = useLocation();

  // Fetch statistics for sidebar
  const { data: statsResponse, isLoading: statsLoading } = useQuery(
    'sidebar-stats',
    apiService.getStatistics,
    {
      refetchInterval: 30000, // Refresh every 30 seconds
      retry: 3,
    }
  );

  const stats = statsResponse?.data || null;

  const navItems = [
    {
      path: '/dashboard',
      icon: BarChart3,
      label: 'Dashboard',
      description: 'Analytics Overview'
    },
    {
      path: '/messages',
      icon: MessageSquare,
      label: 'Messages',
      description: 'Message Analysis'
    },
    {
      path: '/rules',
      icon: Settings,
      label: 'Rules',
      description: 'Compliance Rules'
    }
  ];

  const isActive = (path) => {
    if (path === '/dashboard') {
      return location.pathname === '/' || location.pathname === '/dashboard';
    }
    return location.pathname === path;
  };

  return (
    <div className="sidebar">
      {/* Header */}
      <div className="sidebar-header">
        <div className="logo">
          <Shield className="logo-icon" />
          <div className="logo-text">
            <h3>AGTI</h3>
            <span>Compliance</span>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        <div className="nav-section">
          <h4 className="nav-section-title">Navigation</h4>
          <ul className="nav-list">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                  >
                    <Icon className="nav-icon" />
                    <div className="nav-content">
                      <span className="nav-label">{item.label}</span>
                      <span className="nav-description">{item.description}</span>
                    </div>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </div>
      </nav>

      {/* System Status */}
      <div className="sidebar-footer">
        <div className="system-status">
          <div className="status-header">
            <Activity className="status-icon" />
            <span>System Status</span>
          </div>
          <div className="status-items">
            <div className="status-item">
              <div className="status-indicator online"></div>
              <span>AI Analysis</span>
            </div>
            <div className="status-item">
              <div className="status-indicator online"></div>
              <span>Blockchain</span>
            </div>
            <div className="status-item">
              <div className="status-indicator online"></div>
              <span>Database</span>
            </div>
          </div>
        </div>

        {/* Quick Stats */}
        <div className="quick-stats">
          <div className="stat-item">
            <AlertTriangle className="stat-icon" />
            <div className="stat-content">
              <span className="stat-value">
                {statsLoading ? '...' : stats?.high_risk_percentage ? `${stats.high_risk_percentage.toFixed(1)}%` : '0%'}
              </span>
              <span className="stat-label">High Risk %</span>
            </div>
          </div>
          <div className="stat-item">
            <MessageSquare className="stat-icon" />
            <div className="stat-content">
              <span className="stat-value">
                {statsLoading ? '...' : stats?.total_messages || 0}
              </span>
              <span className="stat-label">Total Messages</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar; 